<svg
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M6 0C6.30668 0 6.58246 0.18671 6.69636 0.47146L10 8.7306L11.3036 5.47146C11.4175 5.18671 11.6933 5 12 5H15.25C15.6642 5 16 5.33579 16 5.75C16 6.16421 15.6642 6.5 15.25 6.5H12.5078L10.6964 11.0285C10.5825 11.3133 10.3067 11.5 10 11.5C9.69332 11.5 9.41754 11.3133 9.30364 11.0285L6 2.76944L4.69636 6.02854C4.58246 6.31329 4.30668 6.5 4 6.5H0.75C0.335786 6.5 0 6.16421 0 5.75C0 5.33579 0.335786 5 0.75 5H3.49223L5.30364 0.47146C5.41754 0.18671 5.69332 0 6 0Z"
    fill="currentColor"
  />
</svg>
